var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"gzPage"}},[_c('img',{staticClass:"bg",attrs:{"src":_vm.img}}),_c('div',{staticClass:"btn",on:{"click":_vm.goBack}},[_c('img',{attrs:{"src":require("../../assets/img/sy/dzp/back.png")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }